export enum ShareProvider {
  FACEBOOK,
  TWITTER,
  GOOGLEPLUS
}

export namespace ShareProvider {

  export function toString(provider: ShareProvider) {
    switch (provider) {
      case ShareProvider.FACEBOOK:
        return 'facebook'
      case ShareProvider.TWITTER:
        return 'twitter'
      case ShareProvider.GOOGLEPLUS:
        return 'googleplus'
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/social-share/shared/share-provider.enum.ts